import type { ReactNode } from "react";
import { HomePageSkeleton } from "./components/common/home-page-skeleton";
import { Navigate, useLocation } from "react-router-dom";
import { AppRoutes } from "./common/routes/app_routes";
import type { UserDto } from "./api";

export function RequireAuth({
  children,
  user,
  isLoading,
}: {
  children: ReactNode;
  user?: UserDto;
  isLoading: boolean;
}) {
  const location = useLocation();

  if (isLoading) {
    return <HomePageSkeleton />;
  }

  if (!user) {
    return <Navigate to={AppRoutes.LOGIN} state={{ from: location }} replace />;
  }

  return children;
}
